import React from "react";

import { Box, Stack, Typography } from "@mui/material";

import useLocalization from "../../hooks/useLocalization";

const MatrixItemsDisplay = ({ matrixItems }) => {
  const { getMessage } = useLocalization();

  return (
    <Box>
      {Array.isArray(matrixItems) && matrixItems.length > 0 ? (
        <Stack>
          {matrixItems.map((item) => (
            <Box>
              <Typography sx={{ fontSize: "10px" }}>{item.name}</Typography>
            </Box>
          ))}
        </Stack>
      ) : (
        <Typography>{getMessage("notset")}</Typography>
      )}
    </Box>
  );
};

export default MatrixItemsDisplay;
